<template>
    <div class="webhook-data-item">
        <div class="btnGroup">
            <SupsisButton
                v-for="item in ['static', 'dynamic']"
                :classNames="selectType === item ? 'btnGroupItem selected' : 'btnGroupItem '"
                :primary="selectType === item"
                :ghost="selectType !== item"
                @click="selectType = item"
                small
                :key="item"
            >
                {{ item }}
            </SupsisButton>
        </div>
        <TiptapEditor
            v-if="selectType === 'dynamic'"
            placeholder="Tag"
            :show-attributes="true"
            :max-character-count="500"
            v-model="clone.value"
            automation-mode
        />
        <TagPicker v-else v-model="clone.value" />
        <SupsisButton small danger @click="deleteItem" v-if="isDeleteButtonVisible"
            ><i class="material-icons">delete</i></SupsisButton
        >
    </div>
</template>
<script>
import Vue from "vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import _ from "lodash";
import TagPicker from "../../pickers/TagPicker.vue";

export default Vue.extend({
    name: "UpdateInfo",
    components: { SupsisButton, TiptapEditor, CustomPicker, TagPicker },
    props: ["payload", "isDeleteButtonVisible", "type", "selectedType"],
    data() {
        const clone = _.cloneDeep(this.payload) || {
            field: null,
            value: null,
        };
        return {
            clone,
            selectType: this.selectedType || "static",
        };
    },
    methods: {
        deleteItem() {
            this.$emit("delete");
        },
    },
    mounted() {
        console.log("updateTag mounted clone", this.clone);
    },
    watch: {
        selectType(val) {
            this.selectType = val;
            this.clone.value = "";
        },
        clone: {
            deep: true,
            handler(newValue) {
                console.log("updateTag this.clone", newValue);
                this.clone.field = this.type;
                this.$emit("save", newValue);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.webhook-data-item {
    display: flex;
    flex-direction: row;
    gap: 10px;

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }
}
</style>
